import { popDelayTime } from "../../../helpers/paymentHelpers/paymentConstants";

export default {
  namespaced: true,
  state: {
    errorModalOpen: false,
    content : {
        message: "",
        headerText: "",
        rightCTAText: '',
        leftCTAText: ''
    },
    paymentFailedContent: {
      isPaymentFailedShow: false,
      bodyMessage: ""
    },
    isRemovePromo: false,
    removePromoCode: {},
    addPromoCode: "",
    currentSelectForChangePaymentModeForBinOffer: {},
    isApplyPromoButtonActive: false,

    popContent: {
      bodyMsg: "",
      headerMsg: "",
      popupDelayTime: 20000,
      isPopOpen: false,
    },
    tempSelectedModeOnlyForExplictPromoCase: {
      type: "",
      isFromModal: false,
      data: {}
    }, 
    notApplicablePromoData: {
      isNotApplicablePromoDataOpen: false,
      notApplicableResponse: {},
    },
    refreshLoadModal: false,
    applyOfferShim: {code: "", payload: false},
    isDuplicatePossModal: false,
    duplicatePossMsg: ""
  },
  getters: {},
  mutations: {
    updateDuplicateMsg(state, payload){
      state.duplicatePossMsg = payload;
    },
    updateIsDuplicatePossModal(state, payload){
      state.isDuplicatePossModal = payload;
      payload ? 
      document.body.classList.add("body-stop-scroll-mobile") :
      document.body.classList.remove("body-stop-scroll-mobile")
    },
    updateApplyOfferShim(state, payload){
      state.applyOfferShim = {...state.applyOfferShim ,...payload}
    },
    updateRefreshLoadModal(state, payload){
      state.refreshLoadModal = payload
      payload ? 
      document.body.classList.add("body-stop-scroll-mobile") :
      document.body.classList.remove("body-stop-scroll-mobile")
    },
    updateNotApplicablePromoData(state, payload){
      state.notApplicablePromoData.isNotApplicablePromoDataOpen = payload
    },
    updateNotApplicableResponse(state, payload){
      state.notApplicablePromoData.notApplicableResponse = payload || {}
    },
    updateTempSelectedModeOnlyForExplictPromoCase(state, payload){
      state.tempSelectedModeOnlyForExplictPromoCase = payload || {};
    },
    udpateIsApplyPromoButtonActive(state, payload){
      state.isApplyPromoButtonActive = payload
    },
    updatePopContent(state, payload){
      const { bodyMsg = "", headerMsg = "", delayTime = popDelayTime.time_20sec, isPopOpen } = payload;
      if(isPopOpen){
        state.popContent.bodyMsg = bodyMsg;
        state.popContent.headerMsg = headerMsg;
        state.popContent.popupDelayTime = delayTime
        state.popContent.isPopOpen = isPopOpen;
      } else {
        state.popContent.isPopOpen = isPopOpen;
      }

    },
    updateCurrentSelectForChangePaymentModeForBinOffer(state, payload){
      state.currentSelectForChangePaymentModeForBinOffer = payload || {};
    },
    updateRemovePromoCode(state, payload){
      state.removePromoCode = payload || {};
    },
    updateAddPromoCode(state, payload){
      state.addPromoCode = payload;
    },
    updateIsRemovePromo(state, payload){
      state.isRemovePromo = payload;
      payload ? document.body.classList.add("body-stop-scroll-mobile") :
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    updateErrorModalOpen(state, payload) {
      state.errorModalOpen = payload
      payload ? 
      document.body.classList.add("body-stop-scroll-mobile") :
      document.body.classList.remove("body-stop-scroll-mobile")
    }
  },
  actions: {
    updateContent({commit, state}, payload) {
      const { message, headerText, rightCTAText, leftCTAText } = payload;
      state.content.message = message;
      state.content.headerText = headerText;
      state.content.rightCTAText = rightCTAText;
      state.content.leftCTAText = leftCTAText;
    }
  },
};
